export default __webpack_public_path__ + "static/media/a8.fe01c0c4.jpg";